import React from "react";
import {
  Button,
  TextField,
  Grid,
  InputLabel,
  useTheme,
  Box,
} from "@mui/material";

const NumberInputComponent = ({
  label,
  name,
  setField,
  value,
  error,
  showLabel,
}) => {
  const theme = useTheme();
  // Handle increment and decrement
  const handleIncrement = () => setField(name, value + 1);
  const handleDecrement = () => setField(name, Math.max(0, value - 1)); // Prevents negative numbers

  return (
    <Box>
      {showLabel && (
        <Grid container alignItems="center" spacing={2}>
          {/* Input Field + Buttons */}
          <Grid item xs={12} sm={12}>
            {" "}
            {/* Input takes the remaining space */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: "#F9FAFB",
                borderRadius: "8px",
                px: 1,
                py: 0.5,
               
              }}
            >
              <Button
                size="small"
                onClick={handleDecrement}
                sx={{
                  minWidth: 28,
                  height: 28,
                  borderRadius: "6px",
                  p: 0,
                  fontSize: "16px",
                  color: "#555",
                }}
              >
                −
              </Button>

              <TextField
  value={value}
  name={name}
  variant="standard"
  InputProps={{
    readOnly: true,
    disableUnderline: true,
    sx: {
      textAlign: "center",  // Horizontally center the text
      fontSize: "14px",     // Set font size
      width: 40,            // Adjust width as needed (can be set to 100% for full-width)
      lineHeight: 1.5,      // Ensure vertical centering
    },
  }}
/>


              <Button
                size="small"
                onClick={handleIncrement}
                sx={{
                  minWidth: 28,
                  height: 28,
                  borderRadius: "6px",
                  p: 0,
                  fontSize: "16px",
                  color: "#555",
                }}
              >
                +
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default NumberInputComponent;
